//@flow

import {useCallback} from 'react';

import {useToastActions} from '../../modules/toast-alert/utils';
import type {ToastAlert} from '../../modules/toast-alert/duck';

type AlertSeverity = 'error' | 'warning' | 'info' | 'success';

type AlertOptions = {
  type?: AlertSeverity,
  duration?: number,
  onClose?: () => void,
  clearPreviousAlerts?: boolean,
  clickToClose?: boolean,
};

const mapAlertTypeToToastType = (type: AlertSeverity) => {
  switch (type) {
    case 'error':
      return 'danger';
    case 'warning':
      return 'warning';
    case 'info':
      return 'info';
    case 'success':
      return 'success';
    default:
      return 'primary';
  }
};

type AlertContextType = {
  showAlert: (message: string, options?: AlertOptions) => void,
};

export function useAlert(): AlertContextType {
  const {showToast} = useToastActions();

  const showAlert = useCallback(
    (message: string, options: AlertOptions = {}) => {
      const newAlert: ToastAlert = {
        message: '',
        type: mapAlertTypeToToastType(options.type || 'info'),
        duration: options.duration || 5000,
        title: message || '',
        onClose: options.onClose,
      };

      showToast(newAlert);
    },
    [showToast]
  );

  return {showAlert};
}
